export class TableNotFoundError extends Error {
}
